import React from "react";
import Marquee from "react-fast-marquee";
import "./marquee.css";

export default function MarqueeBanner() {
  return (
    <div className="marquee">
      <Marquee speed={60} direction="right" pauseOnHover>
        <span>
          <b className="marquee-star">★</b> FREE 4-HOUR VPK — START THE DAY WITH AN EXCLUSIVE LITERACY HOUR BEFORE CLASS BEGINS • ONLY AVAILABLE HERE!
        </span>
      </Marquee>
    </div>
  );
}
